import React from "react";
import { MapPin, Navigation, Phone, MessageCircle, Mail } from "lucide-react";
import { BRAND, whatsappLink } from "../lib/constants";

export default function LocationMap() {
    const mapsQuery = encodeURIComponent(BRAND.address);
    return (
        <section id="contact" className="relative py-24 md:py-32 bg-cream" data-testid="location-section">
            <div className="max-w-7xl mx-auto px-6 md:px-10">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
                    <div className="lg:col-span-5">
                        <p className="text-xs tracking-[0.3em] uppercase text-forest-700 mb-5">Find us</p>
                        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light text-coffee-900 leading-tight">
                            Hidden in the<br />
                            <span className="italic text-forest-700">Western Ghats.</span>
                        </h2>
                        <div className="mt-8 space-y-5">
                            <InfoLine icon={<MapPin className="h-5 w-5 text-forest-700" />} title="Address" value={BRAND.address} />
                            <InfoLine icon={<Phone className="h-5 w-5 text-forest-700" />} title="Call" value={BRAND.phoneIntl} href={`tel:${BRAND.phone}`} />
                            <InfoLine icon={<Phone className="h-5 w-5 text-forest-700" />} title="Alternate" value={BRAND.phone2Intl} href={`tel:${BRAND.phone2}`} />
                            <InfoLine icon={<Mail className="h-5 w-5 text-forest-700" />} title="Email" value={BRAND.email} href={`mailto:${BRAND.email}`} />
                        </div>

                        <div className="mt-8 flex flex-wrap gap-3">
                            <a
                                href={`https://www.google.com/maps/dir/?api=1&destination=${mapsQuery}`}
                                target="_blank"
                                rel="noreferrer"
                                className="inline-flex items-center gap-2 bg-coffee-900 text-cream px-6 py-3 rounded-full text-sm font-medium hover:bg-coffee-800 transition-colors"
                                data-testid="get-directions-btn"
                            >
                                <Navigation className="h-4 w-4" /> Get Directions
                            </a>
                            <a
                                href={whatsappLink()}
                                target="_blank"
                                rel="noreferrer"
                                className="inline-flex items-center gap-2 bg-[#25D366] text-white px-6 py-3 rounded-full text-sm font-medium hover:-translate-y-0.5 transition-transform"
                                data-testid="location-whatsapp-btn"
                            >
                                <MessageCircle className="h-4 w-4" /> Chat on WhatsApp
                            </a>
                        </div>
                    </div>

                    <div className="lg:col-span-7">
                        <div className="rounded-2xl overflow-hidden border border-sand shadow-sm h-[420px] md:h-[500px]">
                            <iframe
                                title="Veeras Resorts location"
                                src={`https://maps.google.com/maps?q=${mapsQuery}&t=&z=14&ie=UTF8&iwloc=&output=embed`}
                                width="100%"
                                height="100%"
                                style={{ border: 0 }}
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                                data-testid="map-iframe"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

function InfoLine({ icon, title, value, href }) {
    const content = (
        <div className="flex items-start gap-4">
            <div className="mt-1">{icon}</div>
            <div>
                <div className="text-[11px] tracking-[0.3em] uppercase text-coffee-500 mb-1">{title}</div>
                <div className="text-coffee-900 text-base">{value}</div>
            </div>
        </div>
    );
    return href ? <a href={href}>{content}</a> : content;
}
